module.exports = __webpack_public_path__ + "static/media/arch_diagram.83b277f3.png";